STUDIP.domReady(() => {
    STUDIP.Blubber.init();
});
